import { Button, Grid, SectionItem } from '@mairistem/composants';
import { isNewIdentifiant } from '@mairistem/tools';
import { useHistory } from 'react-router';

import ProduitsListe from '@/components/Parametrage/ProduitsListe';
import { baseUrlFront } from '@/routes';

interface RegisseursProps {
  identifiant: string | number;
  autonome?: boolean;
}

const Produits = (props: RegisseursProps) => {
  const { identifiant, autonome } = props;

  const history = useHistory();

  return (
    <Grid stackable relaxed>
      <Grid.Row style={{ paddingTop: 0 }}>
        <Grid.Column width={11} style={{ paddingLeft: 0 }}>
          <SectionItem
            title={
              autonome ? 'Produits encaissables au comptant' : 'Produits encaissés sur facture'
            }
            single
            compact
          >
            {autonome && (
              <Button
                data-testid="gerer-produits"
                basic
                icon="cog"
                content="Gérer les produits"
                onClick={() => history.push(`${baseUrlFront}/parametres?tab=produits`)}
                style={{ position: 'absolute', top: '-4em', right: 0 }}
              />
            )}
            <div style={{ height: 300 }}>
              <ProduitsListe basic empty={isNewIdentifiant(identifiant)} />
            </div>
          </SectionItem>
        </Grid.Column>
        <Grid.Column width={3} />
      </Grid.Row>
    </Grid>
  );
};

export default Produits;
